import React, { useRef, useState, useEffect, useCallback } from "react";
import { Editor } from "@tinymce/tinymce-react";
import {
  Button,
  Container,
  Col,
  Form,
  Image,
  Nav,
  Row,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Modal, 
  Spinner
} from "react-bootstrap";
import { debounce } from "lodash"; // Import lodash debounce function
import excl_i from "../../../assets/images/icons/excl_i.png";
import trash from "../../../assets/images/icons/trash.svg";
import edit from "../../../assets/images/icons/edit.svg"
import { useNavigate, NavLink } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";
import {
  coachUpdate,
} from "../../../utils/api";
import Camera from "../../../assets/images/Camera";
import Upload from "rc-upload";
import banner from "../../../assets/images/coach_details_banner.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import Loader from "../../../Loader/Loader";
import { PulseLoader } from "react-spinners";

const EditProfileStory = (props) => {
  const navigate = useNavigate();
  const { getUserFromToken, user } = useUserContext();
  const [story, setStory] = useState(user.story ? user.story : "");
  const [isLoading, setisLoading] = useState(false);
  const [isSubmitting, setisSubmitting] = useState(false);

  const MAX_CHARACTER_COUNT = 1500;
  const Min_CHARACTER_COUNT = 100;

  const [storyError, setStoryError] = useState(false);

  useEffect(() => {
    const canonicalUrl = window.location.origin + window.location.pathname;
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
    
  }, [user]);

  const handleStory = (e) => {
    setStory(e);
  };


  const onClickSave = async (values) => {
    try {
      setisSubmitting(true)

      if (
        (story && story?.length > MAX_CHARACTER_COUNT) ||
        (story && story?.length < Min_CHARACTER_COUNT)
      ) {
        setStoryError(true);
        setisSubmitting(false);
        return;
      } else {
        setStoryError(false);
      }

      if (story) {
        const formdata = new FormData();
        formdata.append("story", story);
        await coachUpdate(formdata);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      setisSubmitting(false)
    }

    getUserFromToken();
    setisSubmitting(false)
  };

  const tooltipStory = (
    <Tooltip id="tooltip">Share your story in 500 characters or less.</Tooltip>
  );

  return (
    <>
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="profile_edit_forms my_light_modal">
        {/* <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Modal heading</Modal.Title>
        </Modal.Header> */}
        <Form>
          <Container>
            <Row className='g-3'>
              <Col sm="12" lg="12" className="mt-4">
                <div className="d-flex justify-content-between">
                  <Form.Label className="title">Story</Form.Label>
                  <span>
                    <OverlayTrigger placement="top" overlay={tooltipStory}>
                      <Image src={excl_i} />
                    </OverlayTrigger>{" "}
                  </span>
                </div>

                <SunEditor
                  // width="120%"
                  setDefaultStyle="font-family: Arial; font-size: 16px;"
                  setOptions={{
                    uttonList: [
                      ["undo", "redo"],
                      ["font", "fontSize"],
                      ["paragraphStyle", "blockquote"],
                      [
                        "bold",
                        "underline",
                        "italic",
                      ],
                      ["align", "list", "lineHeight"],
                    ],
                    defaultTag: "div",
                    height: 120,
                    showPathLabel: false,
                    borderRadius: 12,
                  }}
                  style={{
                    borderRadius: "12px",
                  }}
                  name="story"
                  setContents={story}
                  onChange={handleStory}
                />

                {storyError && (
                  <div className="text-danger">
                    Story section required minimum 250 and maximum 1500 characters  
                  </div>
                )}
              </Col>
            </Row>
            <Row className='justify-content-end mt-4'>
              <Col sm="auto">
                  <Button variant='success' className='px-5' onClick={onClickSave}>Save</Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </Modal>
    </>
  );
}

export default EditProfileStory;